import './polyfills/fill'

export const Direction = {
  windowUp: 'vertical',
  leftRight: 'scrollLeft'
}
const frameRateMilli = 1000 / 60

export function easeInOutQuad(time: number, start: number, change: number, duration: number) {
  let timeDMilli = time
  timeDMilli /= duration / 2
  if (timeDMilli < 1) {
    return change / 2 * timeDMilli * timeDMilli + start
  }
  timeDMilli--
  return -change / 2 * (timeDMilli * (timeDMilli - 2) - 1) + start
}

/* TODO: AVWebStorefront-718 - Integration Tests */
/* istanbul ignore next */
export function scrollTo(element: any, to: number, duration: number,
  direction: string = Direction.leftRight) {
  window.requestAnimationFrame = window.requestAnimationFrame ||
    function timeFn/* istanbul ignore next */(cb: any) {
      return window.setTimeout(cb, frameRateMilli)
    }
  const start = (direction === Direction.windowUp) ? window.scrollY : element[direction]
  const change = to - start
  const frameRate = frameRateMilli
  const framesLength = Math.ceil(duration / frameRate)
  const frames = (new Array(framesLength))
    .fill(0).map((_, index) =>
      easeInOutQuad(frameRate * index, start, change, duration))
  let currentTimeMilli = 0

  const animateScroll = () => {
    currentTimeMilli += frameRate
    /* istanbul ignore next */
    if (currentTimeMilli < duration) {
      if (direction === Direction.windowUp) {
        window.scrollTo(0, frames.shift())
        requestAnimationFrame(animateScroll)
      } else {
        element[direction] = frames.shift()
        requestAnimationFrame(animateScroll)
      }
    } else if (direction === Direction.windowUp) {
      window.scrollTo(0, 0)
    }
  }

  animateScroll()
}

export const leftToScrollPx = (scrollable: HTMLElement) => scrollable.scrollWidth - (scrollable.offsetWidth + scrollable.scrollLeft)